// UI constants used by the canonical Subject Workspace.

export const MAX_PICKER_ROOTS = 120;
export const INITIAL_DISCUSSION_PREVIEW_COUNT = 6;
export const INITIAL_CONTEXT_REPLY_COUNT = 2;
export const CONTEXT_REPLY_BATCH_SIZE = 3;
export const INLINE_COMMENT_PREVIEW_COUNT = 4;
export const INLINE_COMMENT_LIMIT = 3000;
